import { Card } from "@/components/ui/card";
import { formatBRL } from "@/lib/api";

const ST = { pendente: ["NF pendente", "bg-amber-100 text-amber-800"], emitida: ["NF emitida", "bg-emerald-100 text-emerald-800"], sem_nf: ["Só cortesia", "bg-sky-100 text-sky-800"] };

function Linha({ l }) {
  const [txt, cls] = ST[l.nf_status] || ST.pendente;
  return (
    <tr className="border-t border-slate-100 hover:bg-slate-50" data-testid={`fat-linha-${l.inscricao_id}`}>
      <td className="p-2 font-semibold text-slate-900">{l.orgao}</td>
      <td className="p-2">{l.municipio}</td>
      <td className="p-2">{l.uf}</td>
      <td className="p-2 text-right tabular-nums">
        {l.inscritos}
        {l.cortesias > 0 && <div className="text-[10px] text-sky-700">{l.cortesias} cortesia{l.cortesias === 1 ? "" : "s"}</div>}
      </td>
      <td className="p-2 text-right tabular-nums font-bold">{formatBRL(l.valor)}</td>
      <td className="p-2 whitespace-nowrap">{l.data_inicio_txt || "—"}</td>
      <td className="p-2 text-xs text-slate-600 max-w-[260px] truncate" title={l.curso_rotulo}>{l.curso_rotulo}</td>
      <td className="p-2"><span className={`text-[10px] font-bold px-2 py-0.5 rounded-full whitespace-nowrap ${cls}`}>{txt}{l.nf_numero ? ` nº ${l.nf_numero}` : ""}</span></td>
    </tr>
  );
}

export function FaturamentoTabela({ linhas, totais }) {
  if (!linhas.length) {
    return <Card className="p-10 rounded-2xl text-center text-slate-500" data-testid="fat-vazio">Nenhuma inscrição encontrada com esses filtros.</Card>;
  }
  return (
    <Card className="rounded-2xl overflow-x-auto" data-testid="fat-tabela">
      <table className="w-full text-sm">
        <thead className="bg-slate-900 text-white text-xs uppercase tracking-wider">
          <tr>
            {["Órgão / Cliente", "Município", "UF", "Nº de inscritos", "Valor total da NF", "Início do curso", "Curso", "Status"].map((h) => (
              <th key={h} className="p-2 text-left font-bold">{h}</th>
            ))}
          </tr>
        </thead>
        <tbody>{linhas.map((l) => <Linha key={l.inscricao_id} l={l} />)}</tbody>
        <tfoot className="bg-slate-100 font-bold">
          <tr data-testid="fat-totais">
            <td className="p-2" colSpan={3}>Total · {totais.linhas} inscrições em {totais.cursos} curso{totais.cursos === 1 ? "" : "s"}</td>
            <td className="p-2 text-right tabular-nums" data-testid="fat-total-inscritos">{totais.inscritos}</td>
            <td className="p-2 text-right tabular-nums" data-testid="fat-total-valor">{formatBRL(totais.valor)}</td>
            <td className="p-2" colSpan={3}>{totais.cortesias > 0 ? `inclui ${totais.cortesias} cortesia${totais.cortesias === 1 ? "" : "s"} (R$ 0)` : ""}</td>
          </tr>
        </tfoot>
      </table>
    </Card>
  );
}
